<template>
  <div class="wlx-tea-train-wrapper">
    <div class="search-input-con">
      <el-input v-model="Title" size="small" style="width:220px;" placeholder="请输入活动标题"/>
      <el-button
        style="margin-left: 10px;"
        size="small"
        type="primary"
        icon="el-icon-search"
      >搜索</el-button>
    </div>
    <div >
      <el-table :data="table" style="width: 100%">
        <el-table-column label="标题" prop="Title"></el-table-column>
        <!-- <el-table-column label="站点" prop="SiteName"></el-table-column> -->
        <el-table-column label="内容" prop="Content"></el-table-column>
        <el-table-column label="开始时间" prop="PulishTime"></el-table-column>
        <el-table-column label="结束时间" prop="EndTime"></el-table-column>
        <el-table-column label="报名时间" prop="DateCreated"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div style="color: #2D82FF" v-if="scope.row.IsAdop==0">等待处理</div>
            <div style="color: #05C94F" v-if="scope.row.IsAdop==1">已通过</div>
            <div style="color: #E53939" v-if="scope.row.IsAdop==2">未通过</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="u-page-con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attestationList: [],
      SiteList: [],
      siteId_: "",
      attestationId: "",
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      table: [],
      Title: "",
      search:''
    };
  },
  created() {
    this.getAttestation();
  },
  methods: {
    SignUp() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/addAttestationStu", {
          siteId: that.siteId_,
          attestationId: this.attestationId,
          type: 2
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getAttestation(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/teaCertificate/getAttestation", {
          isSys: false,
          Title: this.Title,
          page: page,
          pageSize: this.pageSize
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.table = rst.enrollList;
            that.totalCount = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.currentPage = rst.pagination.pageIndex;
          }else if(rst.code = -1){
            that.table = [];
            that.totalCount = 0;
            that.pageSize = 10;
            that.currentPage = 1;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestation();
    },
    handleCurrentChange(val) {
      this.getAttestation(val);
    }
  }
};
</script>

<style lang="scss">
.wlx-tea-train-wrapper {
  .tea-train-form{
    margin: 8px 62px 0 0;
  }
  .search-input-con{
    text-align: right;
  }
}
</style>
